import { showUserAlert } from "../utils/userErrorMessage";
// Component/Login.jsx
import React, { useState } from "react";
import { supabase } from "../supabase/client";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    const loginEmail = email.trim();
    const { data, error } = await supabase.auth.signInWithPassword({ email: loginEmail, password });

    if (error) {
      const isBannedAccount =
        error.code === "user_banned" || /user\s+is\s+banned|banned/i.test(error.message || "");
      if (isBannedAccount) {
        const { data: signupStatus } = await supabase.functions.invoke("signup-requests", {
          body: { action: "login_status", email: loginEmail, password },
        });
        showUserAlert(
          signupStatus?.status === "rejected"
            ? "로그인 실패: 회원 가입 신청이 운영자에 의해 거절되었습니다. 필요한 경우 운영자에게 문의해 주세요."
            : "로그인 실패: 아직 운영자의 확인이 완료되지 않았습니다. 회원 가입 신청이 승인된 후 다시 로그인해 주세요."
        );
      } else {
        showUserAlert("로그인 실패: " + error.message);
      }
      return;
    }

    const { user } = data;
    if (!user) return;

    // 로그인 성공: 사용자 정보를 저장
    localStorage.setItem("companyId", user.id);
    localStorage.setItem("userEmail", user.email || "");

    // profiles에서 role, must_change_password 조회 (email 기준)
    const { data: profile, error: pErr } = await supabase
      .from("profiles")
      .select("role, must_change_password, company, company_name")
      .eq("email", user.email || loginEmail)
      .single();

    if (pErr) {
      showUserAlert("프로필 조회 실패: " + pErr.message);
      // 조회 실패 시에도 일단 진입
      // navigate("/reservations");
      return;
    }

    const role = profile?.role;
    const mustChanged = !!profile?.must_change_password;
    const company = (profile?.company || user.email || "").trim();
    const companyName = (profile?.company_name || profile?.company || user.email || "").trim();
    if (process.env.NODE_ENV !== "production") console.log("프로필:", profile, "role:", role, "must_change_password:", mustChanged);
    
    localStorage.setItem("role", role);
    localStorage.setItem("email", company);
    localStorage.setItem("companyName", companyName);

    // role이 first/operator/light 이고, 아직 변경하지 않았다면(= false), 비번 변경 페이지로
    if ((role === "first" || role === "operator" || role === "light") && mustChanged === false) {
      navigate("/change-password");
      return;
    }

    // 그 외는 그대로 메인 페이지
    navigate("/reservations");
  };

  return (
    <div className="login-background min-h-screen flex items-center justify-center">
      <div className="bg-white bg-opacity-80 p-6 max-w-sm w-full rounded shadow-md">
        <h2 className="text-lg font-bold mb-4">로그인</h2>
        <input
          className="border w-full p-2 mb-2"
          placeholder="이메일"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="border w-full p-2 mb-4"
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="flex items-center gap-2">
          <button className="bg-blue-500 text-white px-4 py-2" onClick={handleLogin}>
            로그인
          </button>
          <Link className="border border-blue-500 text-blue-700 px-4 py-2" to="/signup-request">
            회원 가입 신청
          </Link>
        </div>
      </div>
    </div>
  );
}
